import { Injectable } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

@Injectable({
  providedIn: SharedModule
})
export class GlobalSettingsService {

  dateFormat = 'MM/dd/yyyy';
  hypenDateFormat = 'yyyy-MM-dd';
  dateTimeFormat = 'MM/dd/yyyy HH:mm';
  linuxDateTimeFormat = "yyyy-MM-dd'T'HH:mm";
  longDateFormat = 'MMMM dd, yyyy';
  monthFormat = 'yyyy/MM';
  yearFormat = 'yyyy';

  constructor() { }
}
